export const ROUTE_PATH = '/commissar-answer';
